export interface CrmConfig {
  oidcAuthority: string
  oidcClientId: string
  oidcScope: string
  apiBaseUrl: string
}

declare global {
  interface Window {
    __CRM_CONFIG__?: Partial<CrmConfig>
  }
}

const defaults: CrmConfig = {
  oidcAuthority: 'https://auth.zitemark.se/hemagg',
  oidcClientId: 'hemagg-crm-web',
  oidcScope: 'openid profile email hemagg-crm-api',
  apiBaseUrl: '',
}

export const config: CrmConfig = { ...defaults, ...(window.__CRM_CONFIG__ ?? {}) }

/** Build an absolute API URL. With an empty apiBaseUrl, calls are same-origin. */
export function apiUrl(path: string): string {
  const base = config.apiBaseUrl.replace(/\/$/, '')
  const suffix = path.startsWith('/') ? path : `/${path}`
  return `${base}${suffix}`
}
